import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  & .MuiInput-root {\n    font-size: ", ";\n    line-height: 1.1;\n    margin-top: 14px;\n  }\n  & .MuiInput-input {\n    padding: 2px 0 5px;\n  }\n  & .MuiInput-underline:after {\n    border-bottom-color: ", ";\n  }\n  & .MuiInput-underline:before {\n    border-bottom: 1px dotted rgba(0, 0, 0, 0.3);\n  }\n  & .MuiInputLabel-root {\n    font-size: ", ";\n  }\n  & .MuiInputLabel-formControl:not(.MuiInputLabel-shrink) {\n    transform: translate(0, 18px) scale(1);\n  }\n  & .MuiInputLabel-root.Mui-focused {\n    color: ", ";\n  }\n"], ["\n  width: 100%;\n  & .MuiInput-root {\n    font-size: ", ";\n    line-height: 1.1;\n    margin-top: 14px;\n  }\n  & .MuiInput-input {\n    padding: 2px 0 5px;\n  }\n  & .MuiInput-underline:after {\n    border-bottom-color: ", ";\n  }\n  & .MuiInput-underline:before {\n    border-bottom: 1px dotted rgba(0, 0, 0, 0.3);\n  }\n  & .MuiInputLabel-root {\n    font-size: ", ";\n  }\n  & .MuiInputLabel-formControl:not(.MuiInputLabel-shrink) {\n    transform: translate(0, 18px) scale(1);\n  }\n  & .MuiInputLabel-root.Mui-focused {\n    color: ", ";\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  & .MuiInputLabel-root {\n    font-size: ", ";\n  }\n  & .MuiInputLabel-formControl {\n    transform: translate(0, 2px) scale(1);\n  }\n  & .MuiInput-underline:before {\n    border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n  }\n"], ["\n  width: 100%;\n  & .MuiInputLabel-root {\n    font-size: ", ";\n  }\n  & .MuiInputLabel-formControl {\n    transform: translate(0, 2px) scale(1);\n  }\n  & .MuiInput-underline:before {\n    border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n  }\n"]);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
/** @jsx jsx */


import React, { Component } from "react";
import { get } from "lodash-es";
import { jsx, css } from "@emotion/core";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Button, Box, TextField } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Form, Field } from "react-final-form";
import { formatters } from "../core/common";
import { muiTheme, palette, darkButtonStyles } from "./styles";
import FormulaInput from "./FormulaInput";
import "./inline-formula.css";
var commonFontSize = "0.8rem";
var fieldStyles = css(_templateObject, commonFontSize, palette.black, commonFontSize, palette.black);
var formulaFieldStyles = css(_templateObject2, commonFontSize);
var FormulaForm = (_temp2 = _class = function (_Component) {
  _inherits(FormulaForm, _Component);

  function FormulaForm() {
    var _temp, _this, _ret;

    _classCallCheck(this, FormulaForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.newValue = _this.props.value, _this.handleSubmit = function (_ref) {
      var name = _ref.name,
          formatter = _ref.formatter;
      var onSave = _this.props.onSave;

      try {
        onSave(_this.newValue, name, get(formatters.find(function (_ref2) {
          var key = _ref2.key;
          return key === formatter;
        }), "formatter"));
      } catch (_ref3) {
        var _ref4;

        var field = _ref3.field;
        var code = _ref3.code;
        return _ref4 = {}, _ref4[field] = code, _ref4;
      }
    }, _this.handleKeyDown = function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();

        _this.handleSave();
      }
    }, _this.handleValueChange = function (value) {
      // not storing it in state to avoid unnecessary re-renders
      _this.newValue = value;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FormulaForm.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        id = _props.id,
        name = _props.name,
        formatter = _props.formatter,
        value = _props.value,
        onClose = _props.onClose,
        showCloseButton = _props.showCloseButton,
        showSaveButton = _props.showSaveButton,
        store = _props.store;
    return jsx(Form, {
      initialValues: {
        name: name,
        formatter: formatters.find(function (f) {
          return f.formatter === formatter;
        }).key,
        value: value
      },
      onSubmit: this.handleSubmit
    }, function (_ref5) {
      var handleSubmit = _ref5.handleSubmit,
          isSubmitting = _ref5.isSubmitting;
      return jsx(Box, {
        component: "form",
        p: "12px",
        width: 200,
        onSubmit: handleSubmit
      }, jsx(Box, {
        display: "flex"
      }, jsx(Box, {
        flexGrow: 1
      }, jsx(Box, {
        mb: 1
      }, jsx(Field, {
        name: "name",
        type: "text"
      }, function (_ref6) {
        var _ref6$input = _ref6.input,
            type = _ref6$input.type,
            input = _objectWithoutProperties(_ref6$input, ["type"]),
            meta = _ref6.meta;

        var validation = meta.submitError && !meta.dirtySinceLastSubmit && meta.touched && {
          error: true,
          helperText: meta.submitError
        };
        return jsx(TextField, _extends({
          css: fieldStyles,
          label: "name",
          inputProps: {
            maxLength: 15,
            autoComplete: "off",
            autoCorrect: "off",
            spellCheck: false
          }
        }, input, validation));
      })), jsx(Box, {
        mb: 1
      }, jsx(Field, {
        name: "formatter"
      }, function (_ref7) {
        var _ref7$input = _ref7.input,
            type = _ref7$input.type,
            input = _objectWithoutProperties(_ref7$input, ["type"]),
            meta = _ref7.meta;

        var validation = meta.submitError && !meta.dirtySinceLastSubmit && meta.touched && {
          error: true,
          helperText: meta.submitError
        };
        return jsx(TextField, _extends({
          css: fieldStyles,
          label: "format",
          inputProps: {
            maxLength: 15,
            autoComplete: "off",
            autoCorrect: "off",
            spellCheck: false
          }
        }, input, {
          select: true,
          SelectProps: {
            "native": true
          }
        }, validation), formatters.map(function (_ref8) {
          var key = _ref8.key,
              text = _ref8.text;
          return jsx("option", {
            key: key,
            value: key
          }, text);
        }));
      }))), showCloseButton && jsx(Box, {
        ml: 2
      }, jsx(CloseIcon, {
        style: {
          cursor: "pointer"
        },
        onClick: onClose,
        fontSize: "small"
      }))), jsx(Box, {
        mt: "10px"
      }, jsx(TextField, {
        css: formulaFieldStyles,
        label: "value / formula",
        InputProps: {
          inputComponent: FormulaInput,
          inputProps: {
            id: id,
            store: store,
            value: value,
            wrapperClassName: "rxp-formula-input",
            height: 44,
            onChange: _this2.handleValueChange,
            onSave: handleSubmit
          }
        }
      })), showSaveButton && jsx(Box, {
        mt: 2,
        display: "flex",
        justifyContent: "flex-end"
      }, jsx(Button, {
        css: darkButtonStyles,
        variant: "outlined",
        size: "small",
        type: "submit",
        disabled: isSubmitting
      }, "Save")));
    });
  };

  return FormulaForm;
}(Component), _class.defaultProps = {
  showCloseButton: true,
  showSaveButton: true
}, _temp2);

var withTheme = function withTheme(props) {
  return jsx(MuiThemeProvider, {
    theme: muiTheme
  }, jsx(FormulaForm, props));
};

export default withTheme;